import { Reveal } from "../Reveal";
import { Chapter } from "../Chapter";
import { PhotoSlot } from "../PhotoSlot";

const PATHS = [
  {
    t: "It just stopped working.",
    d: "There wasn’t one enormous event. Somewhere along the way, you stopped being good together.",
  },
  {
    t: "One of you decided it was over. The other didn’t.",
    d: "You’re trying to catch up emotionally with a decision you didn’t make.",
  },
  {
    t: "You’re not even sure whether you’re separating.",
    d: "You’re somewhere in between. Still together perhaps, but unsure whether there’s a way back.",
  },
  {
    t: "One of you wanted something different.",
    d: "A different life. A different place. A different version of the future.",
  },
  {
    t: "Something happened that changed everything.",
    d: "An affair. A betrayal. A discovery. Something that couldn’t simply be put back in the box.",
  },
  {
    t: "The relationship ended. The difficulty didn’t.",
    d: "Children. New partners. Money. Distance. Resentment. Two homes. Trying to co-parent when you can barely talk.",
  },
];

export const Situations = () => (
  <section className="mx-auto max-w-6xl px-5 md:px-8 py-20 md:py-28" data-testid="how-you-got-here-section">
    <Chapter
      n={1}
      kicker="How you got here"
      title="No two separations look quite the same."
    />
    <div className="grid gap-14 md:grid-cols-12 md:gap-10">
      <div className="md:col-span-7">
        <ul>
          {PATHS.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.04}>
              <li
                className="border-t border-ink/10 py-7 last:border-b"
                data-testid={`path-${i}`}
              >
                <h3 className="font-serif text-xl md:text-2xl leading-snug text-ink">
                  {s.t}
                </h3>
                <p className="mt-2 text-base leading-relaxed text-ink/60">
                  {s.d}
                </p>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
      <div className="md:col-span-5 md:pt-6">
        <Reveal delay={0.1}>
          <PhotoSlot
            src="/images/headphones-coast.jpg"
            alt="Luke standing on the beach looking out to sea, wearing white wired headphones"
            ratio="aspect-[4/3]"
            position="object-center"
            testid="situations-photo"
          />
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-base md:text-lg text-ink/65 leading-relaxed" data-testid="chapter-01-resolve">
            However you got here, there’s usually more going on than the
            argument you’re having today.
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <p className="mt-8 font-serif text-2xl md:text-3xl leading-snug tracking-tight text-ink" data-testid="chapter-01-closing">
            What happened matters.
            <br />
            <span className="text-pine">What you do next matters too.</span>
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
